import { StyleSheet, Text, TouchableOpacity, View } from "react-native"
import * as Colors from "../../../styles/colors"
import * as Fonts from "../../../styles/typography"

export default function UnityItem({ name, address, value, onPress }) {
    return <View style={styles.unityView}>
        <Text style={styles.nameText}>{name}</Text>
        <Text style={styles.addressText}>{address}</Text>
        {/* <View style={{flexDirection: "row"}}>
            <Text style={{color: Colors.SECONDARY}}>{"MENSALIDADES A PARTIR DE "}</Text>
            <Text style={styles.valueText}>{value}</Text>
        </View> */}
        <TouchableOpacity style={styles.buyButton} onPress={onPress}>
            <Text style={styles.buyText}>{"CONTRATAR"}</Text>
        </TouchableOpacity>
    </View>
}

const styles = StyleSheet.create({
    unityView: {
        alignItems: "flex-start",
        marginVertical: 4,
        backgroundColor: "#ffffff",
        padding: 8,
        borderColor: Colors.SECONDARY,
        borderLeftWidth: 2,
        shadowColor: Colors.GRAY_DARK,
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
        borderRadius: 8,
        width: "45%",
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        width: "100%"
    },
    nameText: {
        fontSize: Fonts.FONT_SIZE_24
    },
    addressText: {
        fontSize: Fonts.FONT_SIZE_14
    },
    valueText: {

    },
    buyButton: {
        backgroundColor: Colors.PRIMARY,
        padding: 8,
        marginTop: 8,
        borderRadius: 4
    },
    buyText: {
        color: Colors.WHITE,
        fontWeight: "500"
    }
})